<!--
 * @Author: Ashley.Liu
 * @Date: 2022-06-16 17:55:58
 * @LastEditTime: 2022-12-07 18:17:19
 * @Description: desc
-->
<template>
  <zm-tooltip
    v-if="menuItem"
    v-model="popoverVisible"
    placement="right"
    :width="width"
    trigger="manual"
    popper-class="menu-popover"
    manual
    v-clickoutside="close"
  >
    <zm-button type="text" @click="openNewPage(menuItem.index)" slot="content">
      open new tab
    </zm-button>
    <zm-menu-item
      :index="menuItem.index"
      @click.native.right.prevent="popoverVisible = !popoverVisible"
      :style="itemStyle"
    >
      <i :class="menuItem.icon" />
      <template slot="title">
        <div v-if="collapse" class="nav-item collapse">{{ menuItem.name }}</div>
        <div class="nav-item" v-else>
          <router-link :to="menuItem.index" exact v-text="menuItem.name">
          </router-link>
        </div>
      </template>
    </zm-menu-item>
  </zm-tooltip>
</template>

<script>
import Clickoutside from '@zoom/zoom-ui/src/utils/clickoutside'
export default {
  name: 'MenuItem',
  directives: { Clickoutside },
  props: {
    isFirst: {
      type: Boolean,
      default: false,
    },
    menuItem: {
      type: Object,
      default: () => {
        return {}
      },
    },
    width: {
      type: String,
      default: '100',
    },
    collapse: {
      type: Boolean,
      default: false,
    },
    itemStyle: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      popoverVisible: false,
    }
  },
  methods: {
    openNewPage(index) {
      window.open(location.origin + '/#' + index, '_blank')
      this.popoverVisible = false
    },
    close() {
      this.popoverVisible = false
    },
    onmousedown(e, item) {
      if (e.ctrlKey) {
        this.openNewPage(item.index)
      }
    },
  },
}
</script>

<style scoped lang="scss">
::v-deep {
  .zm-tooltip {
    line-height: 39px;
    padding-left: 13px !important;
  }
}
.menu-popover {
  width: 100px;
}
.nav-item,
.nav-item a {
  font-size: 16px;
  line-height: 21px;
  color: inherit;
  text-decoration: none;
}
</style>
